export default "__VITE_ASSET__rs7OZJaZ__"